import { render, staticRenderFns } from "./decoration-policy-detail-info.vue?vue&type=template&id=57eaf0c8&scoped=true&"
import script from "./decoration-policy-detail-info.vue?vue&type=script&lang=js&"
export * from "./decoration-policy-detail-info.vue?vue&type=script&lang=js&"
import style0 from "./decoration-policy-detail-info.vue?vue&type=style&index=0&id=57eaf0c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57eaf0c8",
  null
  
)

export default component.exports